import gql from 'graphql-tag';

import { createUseMutation } from 'app/graphql/apolloFactoryHelpers';
import { UpsertLookupRow, UpsertLookupRowVariables } from 'app/graphql/generated/graphqlApolloTypes';

export const UPSERT_LOOKUP_ROW = gql`
  mutation UpsertLookupRow($input: UpsertLookupInput) {
    upsertLookupRow(input: $input) {
      fileId
      lookupId
      lookupType
      metadata {
        tableData
        tableSchema
      }
    }
  }
`;

export const useUpsertLookupRow = createUseMutation<UpsertLookupRow, UpsertLookupRowVariables>(UPSERT_LOOKUP_ROW);
